<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.23913 1H1V7.23913" stroke="#947CF7" stroke-width="2" stroke-linecap="round"/>
    <path d="M7.23913 23.5H1V17.2609" stroke="#947CF7" stroke-width="2" stroke-linecap="round"/>
    <path d="M17.2609 1H23.5V7.23913" stroke="#947CF7" stroke-width="2" stroke-linecap="round"/>
    <path d="M17.2609 23.5H23.5V17.2609" stroke="#947CF7" stroke-width="2" stroke-linecap="round"/>
</svg>